module.exports = __webpack_public_path__ + "img/culture_item3.4bb1fabf.png";